import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { transferDiscount } from '@/mocks/pricingData';

export default function TransferDiscount() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('pricing.transfer.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('pricing.transfer.title')}
          </h2>
          <p className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">
            {transferDiscount.titleEn}
          </p>
          <div className="gold-line mx-auto"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mt-6 max-w-[650px] mx-auto">
            {lang === 'en' ? t('pricing.transfer.lead') : transferDiscount.lead}
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-6 max-w-[900px] mx-auto">
          {transferDiscount.discounts.map((discount, idx) => (
            <div
              key={idx}
              className="card-glow flex-1 border border-primary-700/40 bg-primary-800/30 p-6 md:p-8"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500/15 rounded-full flex-shrink-0">
                  <i className="ri-arrow-right-up-line text-accent-400 text-base"></i>
                </div>
                <div>
                  <p className="text-[13px] text-primary-300 tracking-[0.05em]">
                    {lang === 'en' ? t(`pricing.transfer.${idx}.from`) : discount.from}
                  </p>
                  <div className="flex items-center gap-1">
                    <i className="ri-arrow-down-line text-accent-400 text-xs"></i>
                    <p className="text-[13px] text-foreground-100 tracking-[0.05em] font-medium">
                      {lang === 'en' ? t(`pricing.transfer.${idx}.to`) : discount.to}
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center py-3 mb-3 border-y border-primary-700/30">
                <span className="text-[22px] text-accent-400 tracking-[0.06em] font-medium">
                  &#x25B2;{parseInt(discount.amount).toLocaleString()}
                </span>
                <span className="block text-[12px] text-primary-400 tracking-[0.04em] mt-0.5">
                  {t('pricing.transfer.taxNote')}
                </span>
              </div>

              <p className="text-[14px] text-primary-200 tracking-[0.03em] leading-relaxed">
                {lang === 'en' ? t(`pricing.transfer.${idx}.desc`) : discount.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-[13px] text-primary-400 tracking-[0.03em] mt-8">
          {t('pricing.transfer.consultNote')}
          <Link to="/consultation" className="text-accent-400 hover:text-accent-300 underline underline-offset-2 transition-colors mx-1">
            {t('pricing.transfer.consultLink')}
          </Link>
          {t('pricing.transfer.consultNoteSuffix')}
        </p>
      </div>
    </section>
  );
}
